import { createBrowserRouter } from 'react-router';
import { LoadingSkeleton } from '../components/shared/Skeleton';
import { RouteErrorState } from '../components/shared/RouteErrorBoundary';

let router: ReturnType<typeof createBrowserRouter> | undefined;

/** One browser history owner; domain reads stay in Query, not route loaders. */
export function getAppRouter() {
  return router ??= createBrowserRouter([{
    path: '*',
    lazy: async () => ({ Component: (await import('../App')).App }),
    HydrateFallback: () => <main id="main-content" className="halo-route-skeleton"><LoadingSkeleton variant="page" label="加载中 / Loading" /></main>,
    ErrorBoundary: () => <RouteErrorState language={document.documentElement.lang.startsWith('en') ? 'en' : 'zh'} returnHref="/" />,
  }]);
}
